// extracted by mini-css-extract-plugin
module.exports = {"side-list":"_1PI-yggX8qixad8cTtNnhn","box_center":"_25K8OIvY8XO0HNgJXvVgJr"};